import { computed } from 'vue-demi';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');

export default (props) => {
    const isEditor = !!window.FEGOEditor;

    const cssVar = computed(() => {
        return {
            '--swiper-slide-width': `${rem.str(props.swiperWidth)}`,
            '--swiper-slide-height': `${rem.str(props.swiperHeight)}`,
            '--space-between': `${rem.str(props.spaceBetween)}`,
            '--item-between': `${rem.str(props.itemBetween)}`,
            // '--flex-algin-items': 'center',
            '--editor-help-border': isEditor ? '1px dashed #e5e5e5' : 'none',
            '--index-bg-color': props.indexBgColor,
            '--index-active-bg-color': props.indexActiveBgColor,
            '--index-color': props.indexColor,
            '--index-active-color': props.indexActiveColor,
            '--line-color': props.lineColor
        };
    });

    return {
        cssVar
    };
};
